import {h, Fragment} from "preact"
import { useState, useEffect } from "preact/hooks";
import { useAppState, useProductFilters } from "@nosto/preact";
import { 
    NoResultsV2 as NoResults, 
    ToolbarV2 as Toolbar, 
    ProductsV2 as Products, 
    SidebarV2 as Sidebar, 
    PaginationV2 as Pagination 
} from '../'
import { GridLayoutProvider } from "../../contexts/GridLayoutContext"
import { FiltersPanelStateProvider } from "../../contexts/FiltersPanelStateContext"
import { useCustomConfig } from '../../hooks/useCustomConfig'

const sizeFilters = ["Clothing Size", "Shoe Size"]

export default function Results() {
    const {
        response: { products },
        loading
    } = useAppState();

    const { filters } = useProductFilters()
    const [listing, setListing] = useState([])
    const [firstLoad, setFirstLoad] = useState(true)
    const { customConfig } = useCustomConfig();

    useEffect(() => {

        if (!products) return;

        const appliedSizeFilters = filters.filter(f => sizeFilters.includes(f.name))

        let items = products.hits.filter(hit => {
          if (appliedSizeFilters.length === 0) return true
      
          return appliedSizeFilters.every(f => {
            const sku = hit.skus.find(s => s.name === f.value)
            return (!sku || sku.availability !== "OutOfStock" || sku.inventoryLevel > 0)
          })
        }).map(item => ({ ...item, type: 'product' }))

        if (customConfig.featuredItems.length > 0 && items.length > 0) {
            customConfig.featuredItems.forEach(featuredItem => {
                const position = featuredItem.settings?.flex_order_desktop || 0;
                const hideOnFilter = featuredItem.settings?.hide_on_filter;
                if (position > 0 && !(filters.length > 0 && hideOnFilter)) {
                    items.splice(position - 1, 0, { ...featuredItem, type: 'featured_item' })
                }
            })
        }
        setListing(items)

    }, [products, filters])


    // This logic below is intended to scrollTop when filters are applied, except
    // for the first time a user lands in the page
    useEffect(() => {
        if (!products) return;
        if (firstLoad) {
            setFirstLoad(false)
        } else {
            if (customConfig.scrollToStart) 
                customConfig.scrollToStart()
        }
    }, [products])


    //if (!products) return
    return (
        <GridLayoutProvider>
            <FiltersPanelStateProvider>
            
                <Toolbar />
            
                <div className="flex flex-wrap">
                    
                    <Sidebar 
                        className="collection-filter"
                        totalProducts={products?.total || 0}></Sidebar>

                    <div className="collection-wrapper flex-1">
                        {listing?.length > 0 && (
                            <>
                                <Products listing={listing} />
                                <Pagination />
                            </>
                        )}
                        {!loading && (!listing || listing.length === 0) && <NoResults />}
                    </div>

                </div>

            </FiltersPanelStateProvider>
        </GridLayoutProvider>
    )
}
